@if (!loaded) {
  <!-- ── Loading Screen ─────────────────────────────────────────────── -->
  <div class="ld-page" aria-label="Loading" role="status">

    <!-- Background blobs -->
    <div class="ld-bg" aria-hidden="true">
      <div class="ld-bg__blob ld-bg__blob--1"></div>
      <div class="ld-bg__blob ld-bg__blob--2"></div>
      <div class="ld-bg__blob ld-bg__blob--3"></div>

      <!-- Decorative SVG arcs -->
      <svg class="ld-bg__arcs" viewBox="0 0 1440 900" xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="xMidYMid slice">
        <path d="M -200 600 Q 400 200 900 550 T 1700 300" stroke="rgba(111,97,255,0.12)" stroke-width="2" fill="none" />
        <path d="M -100 800 Q 350 400 850 700 T 1600 500" stroke="rgba(111,97,255,0.08)" stroke-width="1.5" fill="none" />
        <path d="M 100 900 Q 600 500 1100 750 T 1800 450" stroke="rgba(111,97,255,0.06)" stroke-width="1" fill="none" />
        <circle cx="1200" cy="120" r="180" stroke="rgba(111,97,255,0.07)" stroke-width="1" fill="none" />
        <circle cx="200" cy="200" r="120" stroke="rgba(111,97,255,0.05)" stroke-width="1" fill="none" />
      </svg>

      <!-- Floating clouds -->
      <div class="ld-bg__clouds">
        <div class="ld-bg__cloud ld-bg__cloud--1"></div>
        <div class="ld-bg__cloud ld-bg__cloud--2"></div>
        <div class="ld-bg__cloud ld-bg__cloud--3"></div>
      </div>
    </div>

    <!-- Glassmorphism loader card -->
    <div class="ld-card" aria-live="polite">

      <!-- Animated icon -->
      <div class="ld-icon" aria-hidden="true">
        <svg class="ld-icon__ring" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="32" cy="32" r="28" stroke="rgba(111,97,255,0.15)" stroke-width="4"/>
          <circle class="ld-icon__arc" cx="32" cy="32" r="28" stroke="url(#ld-grad)" stroke-width="4"
            stroke-linecap="round" stroke-dasharray="88 88"/>
          <defs>
            <linearGradient id="ld-grad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#8b7fff"/>
              <stop offset="100%" stop-color="#5548e0"/>
            </linearGradient>
          </defs>
        </svg>

        <!-- Inner icon -->
        <div class="ld-icon__inner">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H15"
              stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M10 17L15 12L10 7" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M15 12H3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

      <!-- Text -->
      <p class="ld-title">Getting Ready</p>
      <p class="ld-subtitle">Hold on a moment...</p>

      <!-- Dot progress -->
      <div class="ld-dots" aria-hidden="true">
        <span class="ld-dots__dot"></span>
        <span class="ld-dots__dot"></span>
        <span class="ld-dots__dot"></span>
      </div>
    </div>

  </div>
}

@if (loaded) {
  <router-outlet></router-outlet>
}
<meta name="apple-mobile-web-app-capable" content="yes" />

@if (showLoggingSetupButton) {
  <button mat-mini-fab class="!fixed bottom-4 right-4 tis-btn-filled-secondary z-50" (click)="openLoggingSettingsUiDialog()">
    <mat-icon>settings</mat-icon>
  </button>
}